import { Backdrop, Card, Slide, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

import { useStyles } from './SlideModal.styles';

interface SlideModalPropsBase {
  children: React.ReactElement;
  show: boolean;
}
interface SlideModalPropsWithoutClickAway extends SlideModalPropsBase {
  allowClickAway?: never;
  setShow?: never;
}
interface SlideModalPropsWithClickAway extends SlideModalPropsBase {
  allowClickAway: boolean;
  setShow: () => void;
}

type SlideProps =
  | SlideModalPropsWithoutClickAway
  | SlideModalPropsWithClickAway;

export const SlideModal = ({
  allowClickAway = false,
  show,
  setShow,
  children,
}: SlideProps) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const classes = useStyles();

  return (
    <Backdrop
      className={classes.backdrop}
      open={show}
      onClick={() => allowClickAway && setShow?.()}
    >
      <Slide direction={isDesktop ? 'left' : 'up'} in={show} timeout={500}>
        <Card
          className={isDesktop ? classes.offRampCard : classes.slideCard}
          elevation={4}
        >
          {children}
        </Card>
      </Slide>
    </Backdrop>
  );
};

export default SlideModal;
